import { defineComponent as _defineComponent } from 'vue'
import { formattedDate } from '@/composables/utils';
import {
  PropType,
  computed,
  ref,
  onMounted,
  onUnmounted,
  watch,
  nextTick
} from 'vue';
import { PreviewEventGroup } from '../../../../../types/sport';
import { GenericOption } from '../../../../../types/components';
import SpreadSelector from './SpreadSelector.vue';
import Icon from '../icons.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OddsTitle',
  props: {
  title: {
    type: String,
    required: false
  },
  columns: {
    type: Array as PropType<string[]>,
    required: true
  },
  spreadOptions: {
    type: Array as PropType<GenericOption[]>,
    required: false
  },
  selectedSpread: {
    type: Object as PropType<GenericOption>,
    required: false
  },
  hasInfoColumn: {
    type: Boolean,
    required: false,
    default: false
  },
  isFullScreen: {
    type: Boolean,
    required: false,
    default: false
  },
  loading: {
    type: Boolean,
    required: false,
    default: false
  },
  isPreviewMode: {
    type: Boolean,
    required: false,
    default: false
  }
},
  emits: ['spread-change', 'scroll-change'],
  setup(__props, { emit }) {

const props = __props;





const columnsContainer = ref<HTMLElement | null>(null);
const scrollLeft = ref(0);
const canScrollLeft = ref(false);
const canScrollRight = ref(false);

// Funzioni per prevenire lo scroll manuale
const preventScroll = (e: Event) => {
  e.preventDefault();
};

const skeletonColumns = computed(() => {
  const count = (props.columns && props.columns.length) || 3;
  return Array(count).fill('');
});

const updateScrollState = () => {
  if (
    !columnsContainer.value ||
    !props.hasInfoColumn ||
    props.columns.length <= 3
  ) {
    canScrollLeft.value = false;
    canScrollRight.value = false;
    return;
  }

  const container = columnsContainer.value;
  const currentScrollLeft = container.scrollLeft;
  const scrollWidth = container.scrollWidth;
  const clientWidth = container.clientWidth;

  scrollLeft.value = currentScrollLeft;
  // Usa una tolleranza maggiore per gestire arrotondamenti
  canScrollLeft.value = currentScrollLeft > 1;
  canScrollRight.value = currentScrollLeft + clientWidth < scrollWidth - 1;
};

const scrollColumns = (direction: 'left' | 'right') => {
  if (
    !columnsContainer.value ||
    !props.hasInfoColumn ||
    props.columns.length <= 3
  ) {
    return;
  }

  const container = columnsContainer.value;
  const columnCount = props.columns.length;
  const columnWidth = container.scrollWidth / columnCount;
  const scrollAmount = columnWidth * 3;
  const currentScrollLeft = container.scrollLeft;
  const scrollWidth = container.scrollWidth;
  const clientWidth = container.clientWidth;

  let newScrollLeft: number;

  if (direction === 'right') {
    newScrollLeft = Math.min(
      currentScrollLeft + scrollAmount,
      scrollWidth - clientWidth
    );
  } else {
    newScrollLeft = Math.max(currentScrollLeft - scrollAmount, 0);
  }

  container.scrollLeft = newScrollLeft;
  scrollLeft.value = newScrollLeft;

  // Aggiorna lo stato dopo lo scroll
  nextTick(() => {
    updateScrollState();
    emit('scroll-change', newScrollLeft);
  });
};

// Watcher per aggiornare lo stato quando cambiano le colonne o il loading
watch(
  [() => props.columns, () => props.loading, () => props.hasInfoColumn],
  () => {
    nextTick(() => {
      // Aspetta che il DOM sia completamente aggiornato
      setTimeout(() => {
        updateScrollState();
      }, 100);
    });
  }
);

const handleResize = () => {
  nextTick(() => {
    updateScrollState();
  });
};

onMounted(() => {
  nextTick(() => {
    if (columnsContainer.value) {
      // Disabilita lo scroll manuale con il mouse/touch
      if (props.hasInfoColumn && props.columns.length > 3) {
        columnsContainer.value.addEventListener('wheel', preventScroll, {
          passive: false
        });
        columnsContainer.value.addEventListener('touchmove', preventScroll, {
          passive: false
        });
      }
      window.addEventListener('resize', handleResize);
      updateScrollState();
    }
  });
});

onUnmounted(() => {
  if (columnsContainer.value) {
    columnsContainer.value.removeEventListener('wheel', preventScroll);
    columnsContainer.value.removeEventListener('touchmove', preventScroll);
  }
  window.removeEventListener('resize', handleResize);
});

return { __sfc: true,props, emit, columnsContainer, scrollLeft, canScrollLeft, canScrollRight, preventScroll, skeletonColumns, updateScrollState, scrollColumns, handleResize, SpreadSelector, Icon }
}

})